export default import.meta.ROLLDOWN_FILE_URL_fN3GBDImFL4syCUWbqabiA